// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {GetPaymentMethodsResponse} from '..';
import {ComponentOptionsType, MoneiComponent} from '../../types/component';
import {getPaymentMethods} from '../api';
import {config} from '../config';
import {containerTemplate} from '../container';
import {validateComponentProps} from '../utils';
import {BizumModal} from './modal';
import {BizumProps} from './types';

export * from './modal';
export * from './types';

const options: ComponentOptionsType<BizumProps> = {
  tag: 'monei-bizum-button',
  url: config.bizumButtonUrl,
  dimensions: {
    width: '100%',
    height: 'auto'
  },
  autoResize: {
    width: false,
    height: true
  },
  validate: validateComponentProps,
  containerTemplate,
  prerenderTemplate: () => undefined,
  props: {
    accountId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    sessionId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    paymentId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    amount: {
      type: zoid.PROP_TYPE.NUMBER,
      required: false
    },
    currency: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    transactionType: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    language: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    phoneNumber: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    onError: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onLoad: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onBeforeOpen: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onSubmit: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onOpen: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    style: {
      type: zoid.PROP_TYPE.OBJECT,
      alias: 'innerStyle',
      required: false
    },
    __getConfig: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      value: ({props}: any) => {
        return getPaymentMethods.bind(null, props);
      }
    },
    __onClick: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      value: ({props, state}: any) => {
        const rootNode = document.createElement('div');
        document.body.appendChild(rootNode);
        return ({amount, currency}: GetPaymentMethodsResponse) => {
          if (state.isOpen) return;
          let shouldOpen = true;
          if (props.onBeforeOpen) {
            shouldOpen = props.onBeforeOpen();
          }
          if (!shouldOpen) return;
          state.isOpen = true;
          const bizumModal = new BizumModal({
            amount,
            currency,
            ...props,
            onClose: () => {
              state.isOpen = false;
              window.onpopstate = null;
              document.body.style.overflow = '';
            },
            isOpen: true
          });
          window.history.pushState(null, '', window.location.href);
          window.onpopstate = () => bizumModal.updateProps({isOpen: false});
          Object.assign(document.body.style, {overflow: 'hidden'});
          return bizumModal.render(rootNode);
        };
      }
    }
  }
};

export const Bizum: MoneiComponent<BizumProps> = zoid.create(options);
